import { render, staticRenderFns } from "./SalasCadastro.vue?vue&type=template&id=59f6a3d4"
import script from "./SalasCadastro.vue?vue&type=script&lang=js"
export * from "./SalasCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports